export default {
    eventMultiCart(attribute, value, meta) {
        // CONTEXT_FE_COMBO_MODAL is the PHP constant defined in Osit\Event\Stream\Settings
        this.addEvent('CONTEXT_FE_MULTI_CART_MODAL', attribute, value, meta);
    },
    
    eventCombo(attribute, value, meta) {
        // CONTEXT_FE_COMBO_MODAL is the PHP constant defined in Osit\Event\Stream\Settings
        this.addEvent('CONTEXT_FE_COMBO_MODAL', attribute, value, meta);
    },

    // eventLoyalty(attribute, value) {
    //     // CONTEXT_FE_LOYALTY_MODAL is the PHP constant defined in Osit\Event\Stream\Settings
    //     this.addEvent('CONTEXT_FE_LOYALTY_MODAL', attribute, value, {});
    // },

    // eventCheckoutRecomendations(attribute, meta){
    //     // CONTEXT_FE_CHECKOUT_RECOMENDATIONS is the PHP constant defined in Osit\Event\Stream\Settings
    //     this.addEvent('CONTEXT_FE_CHECKOUT_RECOMENDATIONS', attribute, '1', meta);
    // },

    addEvent(context, attribute, value, meta) {
        if(typeof window.mub === "object"){
            window.mub.websiteEvents.add(context, attribute, value, meta);
            return;
        }

        if(typeof Bugsnag !== 'undefined'){
            Bugsnag.notify('webEvent', 'MUB is not defined', {}, 'error');
        }
        else{
            // trigger error, maybe Noibu will catch it
            console.error('MUB is not defined');
        }

        // add to queue
        window.przWebEvQueue = window.przWebEvQueue || [];
        window.przWebEvQueue.push({
            c: context,
            a: attribute,
            v: value,
            m: meta,
        })
    },   

};